function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 42 48"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.13 15h39.74c.62 0 1.13-.5 1.13-1.13V10.5A4.5 4.5 0 0037.5 6H33V1.12C33 .52 32.5 0 31.87 0h-3.75C27.52 0 27 .5 27 1.13V6H15V1.12C15 .52 14.5 0 13.87 0h-3.74C9.5 0 9 .5 9 1.13V6H4.5A4.5 4.5 0 000 10.5v3.38C0 14.48.5 15 1.13 15zm39.74 3H1.13C.5 18 0 18.5 0 19.13V43.5A4.5 4.5 0 004.5 48h33a4.5 4.5 0 004.5-4.5V19.12c0-.61-.5-1.12-1.13-1.12zM6 39c0-1.1.9-2 2-2h1a2 2 0 012 2v4H6v-4zm10-6a2 2 0 00-2 2v8h5v-8a2 2 0 00-2-2h-1zm6-3c0-1.1.9-2 2-2h1a2 2 0 012 2v13h-5V30zm10-7a2 2 0 00-2 2v18h5V25a2 2 0 00-2-2h-1z"
})));